import { motion } from 'framer-motion';
import headerImg from "../assets/images/program.webp";
import Table from "./Table";
import RevealText from './RevealText';
import SectionDivider from './SectionDivider';
import { useReducedMotion } from '../hooks/useReducedMotion';

// Flip to false to hide the entire program section (e.g. after the event).
const SHOW_PROGRAM = false;

// Flip to true once the program is ready to show (vs. the "Uskoro" placeholder).
const SHOW_SOON = false;

const Program = () => {
  const reduceMotion = useReducedMotion();
  const day1 = [
    { time: '16:30h', tema: 'Okupljanje' },
    { time: '17:00h', tema: 'OTVARANJE KONFERENCIJE', prikazi: true,
      fullName: [''],
      lecturerData: ['uvodni govor - Sveučilište u Dubrovniku | Fakultet za medije i odnose s javnošću | Hrvatska udruga za odnose s javnošću'] },
    { time: '17:15h', tema: '1 na 1: Fireside chat: PR unplugged - razgovor bez filtera', prikazi: true,
      fullName: ['Luka Šipić | Ivan Perišić'],
      lecturerData: ['PRo-kreativna agencija Vrh Komunikacije'],
      moderator: '' },
    { time: '18:20h', tema: '1 na 1: Eko je novi trend / „Otpad kao resurs: komunikacija održivosti u praksi”', prikazi: true,
      fullName: ['Marjan Žitnik'],
      lecturerData: ['Maritimo Recycling'],
      moderator: 'Moderatorica: Anamarija Lučić, studentica 2. godine diplomskog studija OSJ' },
    { time: '20:15h', tema: 'KRAJ - Networking i druženje - LOVE BAR' },
  ];

  const day2 = [
    { time: '9:30h',  tema: 'Okupljanje' },
    { time: '10:00h - 10:45h', tema: '1 na 1: Mediji iz prve ruke - iskustvo, izazovi i odgovornost', prikazi: true,
      fullName: [
        'Mario Jurič',
      ],
      lecturerData: [
        'Reporter, urednik i voditelj - RTL | alumni Fakulteta za medije i odnose s javnošću UNIDU',
      ],
      moderator: 'Moderatorica: Dora Vulić, studentica 2. godine prijediplomskog studija MIKD'},
    { time: '10:50h - 11:30h', tema: 'PANEL - Od fakulteta do karijere', prikazi: true,
      fullName: [
        'Ana Kovačević · Monika Lulić · Ivona Antolović',
      ],
      lecturerData: [
        "alumne Fakulteta za medije i odnose s javnošću UNIDU",
      ],
      moderator: 'Moderatorica: Sara Bagić, 3. godina prijediplomskog studija MIKD'
    },
    { time: '11:30h - 11:45h', tema: 'kava pauza' },
    { time: '11:50h - 12:50h', tema: '3 x PR agencije - Odgovornost u PR-u: izazovi agencijskog rada', prikazi: true,
      fullName: [
        'Krešimir Macan',
        'Valentina Mezdić',
        'Jerko Trogrlić',
      ],
      lecturerData: [
        'vlasnik i osnivač agencije Manjgura',
        'voditeljica poslovanja s klijentima u CTA komunikacijama',
        'direktor agencije za odnose s javnošću VAJT d.o.o.',
      ],
      moderator: 'Moderatorica: Karla Sabljić, studentica 1. godine diplomskog studija OSJ'},
    { time: '12:50h - 13:30h', tema: '1 na 1: Komunikacija u službi javnosti: izazovi i odgovornosti', prikazi: true,
      fullName: ['Andrijana Biskup'],
      lecturerData: ['glasnogovornica Policijske uprave DNŽ'],
       moderator: 'Moderatorica: Chiara Agreš, studentica 1. godine prijediplomskog studija MIKD'
    },
    { time: '13:30h - 14:15h', tema: 'CATERING'},
    { time: '14:15h - 14:55h', tema: 'Bez filtera: „Što znači preuzeti odgovornost za svoj put”', prikazi: true,
      fullName: ['Tina Šmanjak'],
      lecturerData: ['poduzetnica Fitzone.hr i Bossy | alumna Fakulteta za medije i odnose s javnošću UNIDU'] },
    { time: '14:55h - 15:55h', tema: 'Iz Dubrovnika do velikih priča i projekata: PR iz prve ruke', prikazi: true,
      fullName: ['Krešimir Macan', 'Tilda Bogdanović'],
      lecturerData: ['vlasnik i osnivač agencije Manjgura', 'vlasnica agencije Dubrovnik PartneR'],
      moderator: 'Moderatorica: Anamarija Lučić, studentica 2. godine diplomskog studija OSJ'
    },
    { time: '16:00h', tema: 'KRAJ' },
  ];

  if (!SHOW_PROGRAM) return null;

  return (
    <>
    <SectionDivider label="Korporativno komuniciranje" labelPosition='right'/>
      <section className='flex flex-col w-full min-h-screen'>
        <header className='pt-16 mx-auto'>
          <h1 className='absolute z-20 text-5xl font-bold text-white md:text-6xl lg:text-8xl'>
            <RevealText>PRogram</RevealText>
          </h1>
          <motion.div
            className='pt-12 lg:pt-20'
            initial={{ opacity: 0, scale: 0.88, y: 16 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1], delay: 0.35 }}
          >
            <img className="rotate-180 w-[240px] lg:w-[480px]" src={headerImg} alt="" loading="lazy" decoding="async" />
          </motion.div>
        </header>
        {SHOW_SOON ? (
          <>
            <Table datum="16.4. Četvrtak" day={day1} />
            <Table datum="17.4. Petak"   day={day2} />
          </>
        ) : (
          <motion.div
            className="flex flex-col items-center justify-center flex-1 gap-6"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={{
              hidden: {},
              visible: { transition: { staggerChildren: 0.2, delayChildren: 0.15 } },
            }}
          >
            <motion.p
              className="text-3xl lg:text-5xl font-thin text-white tracking-widest uppercase"
              variants={reduceMotion
                ? { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { duration: 0.3 } } }
                : { hidden: { opacity: 0, y: 18, filter: 'blur(8px)' }, visible: { opacity: 1, y: 0, filter: 'blur(0px)', transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } } }
              }
            >
              Uskoro
            </motion.p>
            <motion.p
              className="text-xl lg:text-5xl text-[#db9bd5] tracking-wide text-center max-w-2xl lg:max-w-6xl px-6"
              variants={reduceMotion
                ? { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { duration: 0.3 } } }
                : { hidden: { opacity: 0, y: 12, filter: 'blur(6px)' }, visible: { opacity: 1, y: 0, filter: 'blur(0px)', transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } } }
              }
            >
              PRogram će biti objavljen uskoro.
            </motion.p>
            <motion.div
              className="flex gap-3 pt-2"
              variants={{
                hidden:  { opacity: 0 },
                visible: { opacity: 1, transition: { duration: 0.5 } },
              }}
            >
              {[0, 1, 2].map(i => (
                <motion.span
                  key={i}
                  className="h-2 w-2 rounded-full bg-[#db9bd5]"
                  animate={reduceMotion ? { opacity: 1, scale: 1 } : { opacity: [0.2, 1, 0.2], scale: [0.8, 1.3, 0.8] }}
                  transition={reduceMotion ? {} : { duration: 1.5, repeat: Infinity, delay: i * 0.22, ease: 'easeInOut' }}
                />
              ))}
            </motion.div>
          </motion.div>
        )}
      </section>
    </>
  );
};

export default Program;
